import React from 'react';
import * as styles from './exampleSection.module.scss';
import { usePageContext } from '../context/pageContext';
import { SanityExampleSection } from 'graphql-types';
import { Arrow } from '../arrow/Arrow';
import { findTranslation } from '../../utils/findTranslation';

interface Props {
  section: SanityExampleSection;
}

export const ExampleSection: React.FC<Props> = ({ section }) => {
  if (!section) return null;
  const { lang, defaultLang } = usePageContext();
  return (
    <div className={styles.wrapper}>
      <h2>{findTranslation(section?._rawTitleSection, lang, defaultLang)}</h2>
      <div className={styles.allExamples}>
        {section?.allCategories?.categoryItemsList?.map((category, index) => (
          <div
            className={styles.category}
            key={`category-${index}`}
          >
            {category?.activeTitle && (
              <h2
                className={styles.title}
                data-type={section?.colorNav ?? ''}
              >
                {findTranslation(category?._rawLabelCategoryItem, lang, defaultLang)}
              </h2>
            )}
            {category?.exampleItemsList?.map((example, index) => (
              <div
                className={styles.example}
                key={`example-${index}`}
              >
                <Arrow color={section?.colorNav ?? ''} />
                <h4>{findTranslation(example?._rawLabelExampleItem, lang, defaultLang)}</h4>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
